"use client"

import { useEffect, useState } from "react"
import { useTheme } from "next-themes"
import { Moon, Sun } from "lucide-react"
import { cn } from "@/shared/lib/utils"

export function ThemeToggle({ className }: { className?: string }) {
  const { resolvedTheme, setTheme } = useTheme()
  const [terpasang, setTerpasang] = useState(false)

  useEffect(() => setTerpasang(true), [])

  if (!terpasang) {
    return <div className={cn("h-9 w-9 rounded-full bg-secondary animate-pulse", className)} />
  }

  const gelap = resolvedTheme === "dark"

  const toggle = () => {
    const next = gelap ? "light" : "dark"
    const doc = document as any
    if (typeof doc.startViewTransition === "function") {
      doc.startViewTransition(() => setTheme(next))
    } else {
      setTheme(next)
    }
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={gelap ? "Ganti ke mode terang" : "Ganti ke mode gelap"}
      title={gelap ? "Mode terang" : "Mode gelap"}
      className={cn(
        "flex h-9 w-9 items-center justify-center rounded-full text-muted-foreground hover:text-foreground active:bg-secondary transition-colors",
        className,
      )}
    >
      {gelap ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  )
}
